import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../../shared/services/common/dialog/dialog.service';

declare var $: any;

@Component({
  selector: 'app-dialog-error',
  templateUrl: './dialog-error.component.html',
  styleUrls: ['./dialog-error.component.scss']
})
export class DialogErrorComponent implements OnInit {

	message: string;

	constructor(
		public dialogService: DialogService
	) {
		dialogService.errorAlert$.subscribe(message => {
			this.message = message;

			$('#error-modal').modal('show');
		});
	}

	ngOnInit() {
	}

	onEnter() {
		$('#error-modal').modal('hide');
	}
}
